import { getApiClient } from './apiClient';

export const updateTecDocKey = async (tecDocKey) => {
  const client = getApiClient();
  const response = await client.post('/admin/config/update', { tecDocKey });
  return response.data;
};

